export default __webpack_public_path__ + "static/media/comfort2.bffb00df.jpg";